module.exports = require("./rn.d.ts");